import { iMask, tMask, vIncr, vMask } from "../protocol/interface";
export function nextHandle(h) {
    return ((h + vIncr) & vMask) | (h & (tMask | iMask));
}
export function connectAudioNode(node, dest) {
    node.connect(dest);
}
export function disconnectAudioNode(node, dest) {
    node.disconnect(dest);
}
export function setAudioParamValue(param, value) {
    param.value = value;
}
export function len(a) {
    return a.length;
}
export function resize(a, length) {
    a.length = length;
}
export function add(a, e) {
    a.push(e);
}
//# sourceMappingURL=common.js.map